import { Box, Grid, Container } from "@mui/material";
import Background from "../../../components/Background";
import MenteeHeader from "../../../components/MenteeHeader";
import Mobilesidebar from "../../../components/Mobilesidebar";
import Sidebar from "../../../components/Sidebar";
import ChangePlan from "../../../components/ChangePlan";
import { useState } from "react";
import ChangeSponsorPlan from "../../../components/ChangeSponsorPlan";
import { useEditableProfile } from "../../../hooks/useEditableProfile";

const EditSubscription = () => {
  const { profile } = useEditableProfile();
  const role = profile?.roles?.join("_");
  const [searchTerm, setSearchTerm] = useState("");
  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };
  return (
    <Background>
      <MenteeHeader
        searchTerm={searchTerm}
        handleSearchChange={handleSearchChange}
      />
      <>
        <Box
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            padding: {
              xs: "10px 0 20px",
              sm: "10px 0 20px",
              md: "10px 0 20px",
              lg: "10px 0 20px",
              xl: "20px 0 30px",
            },
          }}
        >
          <Container
            maxWidth="xl"
            sx={{ flex: 1, display: "flex", flexDirection: "column" }}
          >
            <Grid
              container
              columnSpacing={{ lg: 3, sm: 2, xs: 2 }}
              sx={{ flex: 1 }}
            >
              <Grid item xs={12} sm={4} md={3}>
                <Mobilesidebar />
                <Sidebar />
              </Grid>
              <Grid item xs={12} sm={8} md={9}>
                <Box
                  sx={{
                    borderRadius: "12px",
                    display: "flex",
                    flexDirection: {
                      xs: "column",
                      sm: "column",
                      md: "column",
                      lg: "row",
                    },
                    gap: {
                      xs: "15px",
                      sm: 0,
                    },
                    height: "100%",
                  }}
                >
                  {role !== "sponsor" ? (
                    <ChangePlan />
                  ) : role === "sponsor" ? (
                    <ChangeSponsorPlan />
                  ) : (
                    ""
                  )}
                </Box>
              </Grid>
            </Grid>
          </Container>
        </Box>
      </>
    </Background>
  );
};

export default EditSubscription;
